import * as React from 'react';
import { useTranslation } from 'react-i18next';
import css from './BeforeAdornment.css';
import { useSelector } from 'react-redux';
import { getSegments } from '@websky/core/src/SearchForm/store/segments/selectors';
import {
	getPassengersForRequest,
	getTotalPassengersCount
} from '@websky/core/src/SearchForm/store/passengers/selectors';
import { useConfig } from '@websky/core/src/context';
import { generateOfferHotelLink } from '@websky/core/src/SearchForm/utils';
import { getLocale } from '@websky/core/src/utils';
import { Locale } from '@websky/core/src/types';

const BeforeAdornment: React.FC = () => {
	const { t } = useTranslation('SearchForm');

	const searchFormState = useSelector(state => state);
	const segments = useSelector(getSegments);
	const passengersCount = useSelector(getTotalPassengersCount);
	const passengers = useSelector(getPassengersForRequest);

	const {
		global: {
			companyInfo: { iataCode }
		},
		SearchForm: {
			offerHotels,
			offerHotelsLink,
			offerHotelsMainLink,
			offerHotelsSupplier,
			offerHotelsAdditionalId,
			offerHotelsUtm
		}
	} = useConfig();

	const transferLink = React.useMemo(() => {
		const currentLocale = getLocale() as string;

		switch (currentLocale) {
			case Locale.Russian:
				return 'https://flyredwings.com/services/transfer/';
			default:
				return 'https://flyredwings.com/en/services/transfer/';
		}
	}, [searchFormState]);

	const eSIMLink = React.useMemo(() => {
		const currentLocale = getLocale() as string;

		return `https://flyredwings.unisim.net/${currentLocale}?utm_source=redwings&utm_medium=wl&utm_campaign=wl&utm_content=main_page_booking_form`;
	}, []);

	const handleHotelsClick = React.useCallback(
		async (e: React.MouseEvent) => {
			e.preventDefault();

			const result = await generateOfferHotelLink(
				offerHotelsLink,
				segments,
				passengersCount,
				passengers,
				iataCode,
				offerHotelsSupplier,
				offerHotelsAdditionalId,
				offerHotelsUtm
			);

			window.open(result || offerHotelsMainLink || offerHotelsLink, '_blank');
		},
		[searchFormState]
	);

	if (!offerHotels) {
		return null;
	}

	return (
		<div className={css.container}>
			<div className={css.aviaTicketsBtn}>{t('Aviatickets')}</div>
			<a className={css.externalBtn} onClick={handleHotelsClick}>
				{t('Hotels')}
			</a>
			<a className={css.externalBtn} onClick={() => window.open(transferLink, '_blank')}>
				{t('Transfer')}
			</a>
			<a className={css.externalBtn} onClick={() => window.open(eSIMLink, '_blank')}>
				{t('eSIM')}
			</a>
		</div>
	);
};

export default BeforeAdornment;
